import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";




import {
  GetAllYesNoListBySubTaskGuid,
  UpdateYesNoList,
} from "../../../Redux/Reducers/Manager/YesNo";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../../Services/Api/ApiServices";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

function YesNo(props) {
  const dispatch = useDispatch();
  const [dataJsonObject, SetDataJsonObject] = useState();
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  const jsonData = useSelector((state) => state.FetchDataJson.JsonData);

  useEffect(() => {
    dataJson();
  }, []);
  const state = useSelector((state) => {
    return {
      YesNoBySubTask: state?.YesNoBySubTask?.YesNoBySubTask,
      YesNoManagerUpdate: state?.YesNoBySubTask?.YesNoManagerUpdate,

      refreshTableStatus: state.refreshTableStatus.refreshTable,
    };
  });
  console.log(state?.YesNoBySubTask, "YesNoBySubTask");

  const [YesNoList, setYesNoList] = useState(state?.YesNoBySubTask);

  const [data, setData] = useState([]);
  const [loding, setLoding] = useState(false);

  useEffect(() => {
    setYesNoList(state?.YesNoBySubTask);
  }, [state?.YesNoBySubTask]);

  console.log(YesNoList, "sss");
  let a = YesNoList;

  const getData = () => {
    if (jsonData.domainUrl)
      axios
        .post(`${jsonData.domainUrl}/api/YseNo/GetAllYesNoListBySubTaskGuid`, {
          subTaskId:null,
          mainTaskId: props.taskId,
        })
        .then((result) => {
          const data = result.data.result;

          const yesNoList = {};
          data.forEach((marks) => {
            if (!yesNoList[marks.questionGroupName]) {
              yesNoList[marks.questionGroupName] = {
                GroupingName: "",
                row: "",
                value: [],
              };
            }
            yesNoList[marks.questionGroupName].GroupingName =
              marks.questionGroupName;
            yesNoList[marks.questionGroupName].row = marks.questionOrder;
            yesNoList[marks.questionGroupName].value.push(marks);
          });
          console.log(yesNoList, "kjkjkjkjj");

          setData(yesNoList);
          setLoding(true);
        });
  };

  useEffect(() => {
    getData();
  }, [state.refreshTableStatus]);

  // const UpdateData = (obj) => {
  //   console.log(obj, "objobj");

  //   dispatch(
  //     UpdateYesNoList({
  //       eV_NT_YesNoEvaluationModel: obj,
  //     })
  //   );
  // };

  useEffect(() => {
    if (props.onDataChange) {
      props.onDataChange(data);
    }
  }, [data]);

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [state.YesNoManagerUpdate]);

return (
  <>
    {data && (
      <SharedDiv
        showTitle={true}
        titleName="ادخال بيانات التقييم"
        child={[
          <div className="table-container" key="evaluation-table">
            <table className="table">
              <thead>
                <tr>
                  <th>المعيار</th>
                  <th>حالة المعيار</th>
                  <th>الشرح</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(data).flatMap((groupKey) =>
                  data[groupKey]?.value.map((item, index) => (
                    <tr key={`${groupKey}-${index}`}>
                      <td>{item.questionName}</td>
                      <td>
                        <AllDropDownsAHSF
                          fieldsName="yesNoTableDropDown"
                          yesNo={true}
                          hidelable={true}
                          show={true}
                          disabled={props.disabled}
                          dropdownType="normal"
                          arrayOoptionList={[
                            { text: "نعم", value: true },
                            { text: "لا", value: false },
                          ]}
                          value={item.evalResponse}
                          KeyText={"text"}
                          KeyValue={"value"}
                          onChange={(e) => {
                            item.evalResponse = JSON.parse(e.target.value);
                            // UpdateData(data[groupKey]?.value);
                          }}
                        />
                      </td>
                      <td>
                        <textarea
                          className="textarea-field"
                          disabled={props.disabled}
                          defaultValue={item.evalReason}
                          onChange={(e) => {
                            item.evalReason = e.target.value;
                            // UpdateData(data[groupKey]?.value);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>,
        ]}
      />
    )}
  </>
);

}

export default YesNo;
